import gql from 'graphql-tag';

export const UPDATE_EQUIPMENT_CONDITION = gql`
  mutation UpdateEquipmentCondition($input: UpdateVOEquipmentConditionInput!) {
    result: updateVOEquipmentCondition(input: $input) {
      error
      success
    }
  }
`;
